import { render, staticRenderFns } from "./customer-loan-request.vue?vue&type=template&id=a90d8750&scoped=true&"
import script from "./customer-loan-request.vue?vue&type=script&lang=js&"
export * from "./customer-loan-request.vue?vue&type=script&lang=js&"
import style0 from "./customer-loan-request.vue?vue&type=style&index=0&id=a90d8750&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90d8750",
  null
  
)

export default component.exports